import React from 'react';
import { Navigate } from 'react-router-dom';

// Função simulada para verificar autenticação
const isAuthenticated = (acess) => {
  if(acess == null){
    return true
  }
  if (acess.includes(localStorage.getItem('tipo'))) {
    return true
  } else {
    return false
  }
};

const PrivateRoute = ({ element, acess }) => {
  return isAuthenticated(acess) ? element : <Navigate to="/" />;
};

export default PrivateRoute;
